import { useMutation, useQuery } from '@apollo/client'
import { Container } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  GetSoftpayPluginDocument,
  PluginId,
  PluginSoftpay,
  UpdateSoftpayDocument,
} from '../../../../generated/graphql'
import {
  AuthenticationDialog,
  AuthenticationDialogForm,
} from '../authentication/dialog'
import { AuthenticationSection } from '../authentication/section'

type Form = PluginSoftpay

export const SettingsSoftpayPage = () => {
  const { t } = useTranslation(['shared', 'apps'])

  const { data, loading: isLoading } = useQuery(GetSoftpayPluginDocument, {
    fetchPolicy: 'cache-and-network',
  })
  const softpayPlugin = data?.softpayPlugin

  const [isAuthOpen, setAuthOpen] = useState(false)
  const isAuthConfigured = Boolean(
    softpayPlugin?.app_username && softpayPlugin?.app_password,
  )

  const [updateSettings] = useMutation(UpdateSoftpayDocument)

  const onAuthSubmit = async (formData: AuthenticationDialogForm) => {
    await updateSettings({
      variables: {
        data: {
          ...softpayPlugin,
          id: PluginId.Softpay,
          app_username: formData.login,
          app_password: formData.password,
        } as Form,
      },
    })
  }

  return (
    <Container>
      <AuthenticationDialog
        open={isAuthOpen}
        onClose={() => setAuthOpen(false)}
        onSubmit={onAuthSubmit}
        defaultValues={{
          login: data?.softpayPlugin.app_username,
        }}
        slotProps={{
          loginInput: {
            label: t('apps:softpay.app_username_label'),
            helperText: t('apps:softpay.app_username_helper'),
          },
          passwordInput: {
            label: t('apps:softpay.app_password_label'),
            helperText: t('apps:softpay.app_password_helper'),
          },
        }}
      />
      <AuthenticationSection
        isConfigured={isAuthConfigured}
        onClick={() => setAuthOpen(true)}
        isLoading={isLoading}
      />
    </Container>
  )
}
